<template>
  <div>
    <!-- <div class="notes">注: 以下页数按A4单面计算，双面、A3自动2倍，双色计入彩色</div> -->
    <Alert type="warning" style="width: 612px;padding-right: 16px;font-size:12px">
      提示：以下页数按A4单面计算，A3和双面将自动2倍A4，双色计入彩色
      <Button type="success" style="margin-left: 96px;" @click="openPdf">查看填写指引</Button>
    </Alert>
    <Form ref="formInline" :model="itemData" :rules="rule" :label-width="160" inline>
      <FormItem prop="name" label="方案名称:">
        <Input style="width:141px" v-model="data.name" placeholder="抄表结算方案名称"/>
      </FormItem>
      <FormItem prop="basics" label="基础金额(元):">
        <InputNumber style="width:141px" :active-change="false" :precision="2" :min="0" :step="1" v-model="data.basics"></InputNumber>
      </FormItem>
      <br/>
      <FormItem prop="black_num" label="免费黑白(页)):">
        <InputNumber style="width:141px" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.black_num"></InputNumber>
      </FormItem>
      <FormItem prop="color_num" label="免费彩色(页):">
        <InputNumber style="width:141px" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.color_num"></InputNumber>
      </FormItem>
      <br/>
      <FormItem label="结算方案描述">
        <Input style="width: 141px" v-model="data.describe"/>
      </FormItem>
      <br/>
      <FormItem label="黑白(页):">
        <div class="type2_row">区间1:
          <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.a.f" @on-blur="formatContent('black')"/> 至

          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('black','a')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.a.t" @on-blur="formatContent('black')" v-if="itemData.black.a.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.black.a.t === -1" value="截至印章" @on-blur="formatEnd($event,'black','a')"/>
          单价(元/页):
          <InputNumber class="input" :min="0" v-model="itemData.black.a.money"/>
        </div>

        <div class="type2_row">区间2:
          <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.b.f" @on-blur="formatContent('black')" disabled/> 至

          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('black','b')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.b.t" @on-blur="formatContent('black')" v-if="itemData.black.b.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.black.b.t === -1" value="截至印章" @on-blur="formatEnd($event,'black','b')"/>
          单价(元/页):
          <InputNumber class="input" :min="0" v-model="itemData.black.b.money"/>
        </div>

        <div class="type2_row">区间3:
          <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.c.f" @on-blur="formatContent('black')" disabled/> 至

          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('black','c')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.c.t" @on-blur="formatContent('black')" v-if="itemData.black.c.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.black.c.t === -1" value="截至印章" @on-blur="formatEnd($event,'black','c')"/>
          单价(元/页):
          <InputNumber class="input" :min="0" v-model="itemData.black.c.money"/>
        </div>
      </FormItem>
      <FormItem label="彩色(页):">
        <div class="type2_row">区间1:
          <InputNumber class="input" :min="0" v-model="itemData.color.a.f" @on-blur="formatContent('color')"/> 至

          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('color','a')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" v-model="itemData.color.a.t" @on-blur="formatContent('color')" v-if="itemData.color.a.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.color.a.t === -1" value="截至印章" @on-blur="formatEnd($event,'color','a')"/>
          单价(元/页):
          <InputNumber class="input" :min="0" v-model="itemData.color.a.money"/>
        </div>

        <div class="type2_row">区间2:
          <InputNumber class="input" :min="0" v-model="itemData.color.b.f" @on-blur="formatContent('color')" disabled/> 至

          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('color','b')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" v-model="itemData.color.b.t" @on-blur="formatContent('color')" v-if="itemData.color.b.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.color.b.t === -1" value="截至印章" @on-blur="formatEnd($event,'color','b')"/>
          单价(元/页):
          <InputNumber class="input" :min="0" v-model="itemData.color.b.money"/>
        </div>

        <div class="type2_row">区间3:
          <InputNumber class="input" :min="0" v-model="itemData.color.c.f" @on-blur="formatContent('color')" disabled/> 至

          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('color','c')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" v-model="itemData.color.c.t" @on-blur="formatContent('color')" v-if="itemData.color.c.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.color.c.t === -1" value="截至印章" @on-blur="formatEnd($event,'color','c')"/>
          单价(元/页):
          <InputNumber class="input" :min="0" v-model="itemData.color.c.money"/>
        </div>
      </FormItem>
      <br/>
      <FormItem>
        <Button type="success" @click="save"  v-preventReClick :loading="loading">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isNull } from 'util'
export default {
  name: 'type2',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      rule: {
        name: [{ validator: (rule, value, cb) => {
          if (!this.data.name) {
            cb(new Error('方案名称未填'))
          } else {
            cb()
          }
        },
        required: true,
        trigger: 'blur' }],
        basics: [{ validator: (rule, value, cb) => {
          if (this.data.basics >= 0) {
            cb()
          } else {
            cb(new Error('基础金额未填'))
          }
        },
        required: true,
        trigger: 'blur' }]
      },
      itemData: {
        black_num: 0,
        color_num: 0,
        black: {
          a: { f: 0, t: -1, money: null },
          b: { f: null, t: null, money: null },
          c: { f: null, t: null, money: null }
        },
        color: {
          a: { f: 0, t: -1, money: null },
          b: { f: null, t: null, money: null },
          c: { f: null, t: null, money: null }
        }
      }
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    openPdf () {
      window.open('https://www.aidprint.com/pdf/qj.pdf')
    },
    initData () {
      if (this.data.id && this.data.type == 2) {
        this.itemData = JSON.parse(this.data.content)
      }
    },
    setEnd (type, row) {
      this.itemData[type][row].t = -1
      this.formatContent(type)
    },
    formatContent (tp) {
      let temp = this.itemData[tp]
      if (temp.a.t > 0) {
        temp.b.f = temp.a.t + 1
      }
      if (temp.b.t) {
        temp.c.f = temp.b.t + 1
      }
      if (temp.a.t === -1) {
        temp.b.f = null
        temp.b.t = null
        temp.c.f = null
        temp.c.t = null
      }
      if (temp.b.t === -1) {
        temp.c.f = null
        temp.c.t = null
      }
      if (temp.a.t !== -1 && temp.a.t <= temp.a.f) {
        temp.a.t = null
        temp.b.f = null
        temp.b.t = null
        temp.c.f = null
        temp.c.t = null
      }
      if (temp.b.t !== -1 && temp.b.t <= temp.b.f) {
        temp.b.t = null
        temp.c.f = null
        temp.c.t = null
      }
      if (temp.c.t !== -1 && temp.c.t <= temp.c.f) {
        temp.c.t = null
      }
    },
    formatEnd (e, type, row) {
      if (e.target.value !== '截至印章') {
        if (isNaN(parseInt(e.target.value))) {
          this.itemData[type][row] = null
        } else {
          this.itemData[type][row].t = parseInt(e.target.value)
        }
      }
      this.formatContent(type)
    },
    save () {
      this.$refs.formInline.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.data.agent_id = this.user.id
          this.data.content = JSON.stringify(this.itemData)
          this.data.type = '2'
          this.SaveMeterCharge(this.data).then(res => {
            if (res) {
              this.data.id = res
              this.$Message.success('保存成功')
            }
            this.loading = false
          })
        }
      })
    },
    ...mapActions(['SaveMeterCharge'])
  },
  computed: mapGetters({
    user: 'agent'
  })
}
</script>

<style lang="less" scoped>
  @import '../index.less';
</style>
